import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, roles, redirectPath = '/unauthorized' }) => {
  const { currentUser, userRole, loading } = useAuth();

  // Show a loading spinner if authentication is still loading
  if (loading) {
    return <div>Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to the unauthorized page if the user role is not allowed
  if (roles && !roles.includes(userRole)) {
    return <Navigate to={redirectPath} replace />;
  }

  // Render the children (protected component)
  return children;
};

export default PrivateRoute;
